import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  unlimited: {
    color: ThemeConstants.transactions.unlimited,
    backgroundColor: ThemeConstants.transactions.unlimitedText,
  },
  basic: {
    backgroundColor: ThemeConstants.transactions.basic,
    color: ThemeConstants.transactions.basicText,
  },
  refund: {
    backgroundColor: ThemeConstants.transactions.refund,
    color: ThemeConstants.transactions.refundText,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
